module.exports = __webpack_public_path__ + "static/media/gatsby-is-my-jam-optimized.3b271adc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/99-conclusion/images/gatsby-is-my-jam-optimized.jpg
// module id = 981
// module chunks = 0